/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
/* eslint-disable object-shorthand */
/* eslint-disable no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import { Box, IconButton } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import CloseIcon from "@mui/icons-material/Close";
import * as Sentry from "@sentry/react";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import Button from "../../../../components/common/Button";
import Typography from "../../../../components/common/new/Typography/Typography";
import { CommonStyles } from "../../../../components/common/Button/commonButtonStyle";
import Member from "../../../../services/api/member";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../../contants";
import AutoCompleteDropdown from "../../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import IntroductionFormApi from "../../../../services/api/introductionForm";
// import InputField from "../../../../components/common/new/InputField/InputField";
import { selectAllSIUsers } from "../../../../redux/selectors/user";
import style from "./HDCModal.style";
import Loader from "../../../../components/common/Loader/Loader";
import { getOptions } from "../../../../utils";

const MEMBER_HDC_CREATE = {
  AREA: "areaId",
  CLUSTER: "clusterId",
  ZONE: "zoneId",
  REGION: "regionId",
  CHAPTER: "chapterId",
  DISTRICT: "districtId",
};
const MEMBER_HDC_CREATE_SECOND = {
  AREA: "areaIdSecond",
  CLUSTER: "clusterIdSecond",
  ZONE: "zoneIdSecond",
  REGION: "regionIdSecond",
  CHAPTER: "chapterIdSecond",
  DISTRICT: "districtIdSecond",
};

function HDCModal({ selectedMember, onClose }) {
  //   const { roles, chapterId, proxyRoles } = selectedMember;
  const {
    areaId,
    clusterId,
    zoneId,
    regionId,
    chapterId,
    // districtId,
    // blockId,
    memberId,
    fullName,
  } = selectedMember;
  const data = selectedMember;
  const [area, setArea] = useState([]);
  const [cluster, setCluster] = useState([]);
  const [zone, setZone] = useState([]);
  const [region, setRegion] = useState([]);
  const [chapter, setChapter] = useState([]);
  const [district, setDistrict] = useState([]);
  const toast = useContext(ToastAlertContext);
  const [secondCluster, setSecondCluster] = useState([]);
  const [secondZone, setSecondZone] = useState([]);
  const [secondRegion, setSecondRegion] = useState([]);
  const [secondChapter, setSecondChapter] = useState([]);
  const [secondDistrict, setSecondDistrict] = useState([]);
  const [hdcData, setHdcData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSecond, setIsLoadingSecond] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const { isHelpDesk, isAreaSi, isClusterSi, isZoneSi, isHelpDeskAdmin } =
    useSelector(selectAllSIUsers);

  const mainlinePosition = selectedMember?.positions?.find(
    (position) => position?.positionType === "MAINLINE_POSITION",
  )?.name;

  const nationalHDC = selectedMember?.positions?.some((position) => {
    const allowedPositionNames = [72, 71, 63, 58];
    // return allowedPositionNames.includes(position.name);
    return (
      allowedPositionNames.includes(position.id) &&
      position.positionType === "MAINLINE_POSITION"
    );
  });

  const areaHDC = selectedMember?.positions?.some((position) => {
    const allowedPositionNames = [62, 61];
    // return allowedPositionNames.includes(position.name);
    return (
      allowedPositionNames.includes(position.id) &&
      position.positionType === "MAINLINE_POSITION"
    );
  });
  const clusterHDC = selectedMember?.positions?.some((position) => {
    const allowedPositionNames = [113, 114, 115];
    // return allowedPositionNames.includes(position.name);
    return (
      allowedPositionNames.includes(position.id) &&
      position.positionType === "MAINLINE_POSITION"
    );
  });

  const zoneHDC = selectedMember?.positions?.some((position) => {
    const allowedPositionNames = [59, 51];
    // return allowedPositionNames.includes(position.name);
    return (
      allowedPositionNames.includes(position.id) &&
      position.positionType === "MAINLINE_POSITION"
    );
  });

  const regionHDC = selectedMember?.positions?.some((position) => {
    const allowedPositionNames = [28, 27];
    // return allowedPositionNames.includes(position.name);
    return (
      allowedPositionNames.includes(position.id) &&
      position.positionType === "MAINLINE_POSITION"
    );
  });

  const Clusters =
    (isHelpDesk || isHelpDeskAdmin) && areaHDC
      ? async () => {
          if (areaId) {
            const response = await IntroductionFormApi.getCluster({
              areaId,
            });
            setCluster(response.data);
          }
        }
      : (isAreaSi && areaHDC) ||
        (isHelpDesk && areaHDC) ||
        (isHelpDeskAdmin && areaHDC)
      ? async () => {
          if (areaId) {
            const response = await IntroductionFormApi.getCluster({
              areaId,
            });
            setCluster(response.data);
          }
        }
      : (isClusterSi && zoneHDC) ||
        (isHelpDesk && zoneHDC) ||
        (isHelpDeskAdmin && zoneHDC)
      ? async () => {
          if (areaId) {
            const response = await IntroductionFormApi.getCluster({
              areaId,
            });
            setCluster(response.data);
          }
        }
      : async (selectedClusterId) => {
          if (selectedClusterId) {
            try {
              const response = await IntroductionFormApi.getCluster({
                areaId: selectedClusterId,
              });
              setCluster(response.data);
            } catch (error) {
              console.error("Error fetching Zones:", error);
            }
          } else {
            setCluster([]);
            setZone([]);
            setRegion([]);
            setChapter([]);
            setDistrict([]);
          }
        };

  const Zones =
    (isHelpDesk || isHelpDeskAdmin) && clusterHDC
      ? async () => {
          if (clusterId) {
            const response = await IntroductionFormApi.getZones({
              clusterId,
            });
            setZone(response.data);
          }
        }
      : (isAreaSi && clusterHDC) ||
        (isHelpDesk && clusterHDC) ||
        (isHelpDeskAdmin && clusterHDC)
      ? async () => {
          if (clusterId) {
            const response = await IntroductionFormApi.getZones({
              clusterId,
            });
            setZone(response.data);
          }
        }
      : (isZoneSi && regionHDC) ||
        (isHelpDesk && regionHDC) ||
        (isHelpDeskAdmin && regionHDC)
      ? async () => {
          if (clusterId) {
            const response = await IntroductionFormApi.getZones({
              clusterId,
            });
            setZone(response.data);
          }
        }
      : async (selectedClusterId) => {
          if (selectedClusterId) {
            try {
              const response = await IntroductionFormApi.getZones({
                clusterId: selectedClusterId,
              });
              setZone(response.data);
            } catch (error) {
              console.error("Error fetching Zones:", error);
            }
          } else {
            setZone([]);
            setRegion([]);
            setChapter([]);
            setDistrict([]);
          }
        };

  const Regions =
    // isAreaSi && zoneHDC
    (isAreaSi && zoneHDC) ||
    (isHelpDesk && zoneHDC) ||
    (isHelpDeskAdmin && zoneHDC)
      ? async () => {
          if (zoneId) {
            const response = await IntroductionFormApi.getRegions({
              zoneId,
            });
            setRegion(response.data);
          }
        }
      : (isZoneSi && regionHDC) ||
        (isHelpDesk && regionHDC) ||
        (isHelpDeskAdmin && regionHDC)
      ? async () => {
          if (zoneId) {
            const response = await IntroductionFormApi.getRegions({
              zoneId,
            });
            setRegion(response.data);
          }
        }
      : async (selectedZoneId) => {
          if (selectedZoneId) {
            try {
              const response = await IntroductionFormApi.getRegions({
                zoneId: selectedZoneId,
              });
              setRegion(response.data);
            } catch (error) {
              console.error("Error fetching Regions:", error);
            }
          } else {
            setRegion([]);
            setChapter([]);
            setDistrict([]);
          }
        };

  const Chapters =
    (isZoneSi && regionHDC) ||
    (isHelpDesk && regionHDC) ||
    (isHelpDeskAdmin && regionHDC)
      ? async () => {
          if (regionId) {
            const response = await IntroductionFormApi.getChapters({
              regionId,
            });
            setChapter(response.data);
          }
        }
      : async (selectedRegionId) => {
          if (selectedRegionId) {
            try {
              const response = await IntroductionFormApi.getChapters({
                regionId: selectedRegionId,
              });
              setChapter(response.data);
            } catch (error) {
              console.error("Error fetching Chapters:", error);
            }
          } else {
            setChapter([]);
            setDistrict([]);
          }
        };

  const Districts = async (selectedChapterId) => {
    if (selectedChapterId) {
      try {
        const response = await IntroductionFormApi.getDistricts({
          chapterId: selectedChapterId,
        });
        setDistrict(response.data);
      } catch (error) {
        console.error("Error fetching Districts:", error);
      }
    } else {
      setDistrict([]);
    }
  };

  // second row data

  const secondClusters = async (selectedAreaId) => {
    if (selectedAreaId) {
      const response = await IntroductionFormApi.getCluster({
        areaId: selectedAreaId,
      });
      setSecondCluster(response.data);
    } else {
      setSecondCluster([]);
      setSecondZone([]);
      setSecondRegion([]);
      setSecondChapter([]);
      setSecondDistrict([]);
    }
  };

  const secondZones =
    (isHelpDesk || isHelpDeskAdmin) && areaHDC
      ? async () => {
          if (clusterId) {
            const response = await IntroductionFormApi.getZones({
              clusterId,
            });
            setSecondZone(response.data);
          }
        }
      : (isClusterSi && zoneHDC) ||
        (isHelpDesk && zoneHDC) ||
        (isHelpDeskAdmin && zoneHDC)
      ? async () => {
          if (clusterId) {
            const response = await IntroductionFormApi.getZones({
              clusterId,
            });
            setSecondZone(response.data);
          }
        }
      : (isZoneSi && regionHDC) ||
        (isHelpDesk && regionHDC) ||
        (isHelpDeskAdmin && regionHDC)
      ? async () => {
          if (clusterId) {
            const response = await IntroductionFormApi.getZones({
              clusterId,
            });
            setSecondZone(response.data);
          }
        }
      : async (selectedClusterId) => {
          if (selectedClusterId) {
            try {
              const response = await IntroductionFormApi.getZones({
                clusterId: selectedClusterId,
              });
              setSecondZone(response.data);
            } catch (error) {
              console.error("Error fetching Zones:", error);
            }
          } else {
            setSecondCluster([]);
            setSecondZone([]);
            setSecondRegion([]);
            setSecondChapter([]);
            setSecondDistrict([]);
          }
        };

  const secondRegions =
    (isAreaSi && zoneHDC) ||
    (isHelpDesk && zoneHDC) ||
    (isHelpDeskAdmin && zoneHDC)
      ? async () => {
          if (zoneId) {
            const response = await IntroductionFormApi.getRegions({
              zoneId,
            });
            setSecondRegion(response.data);
          }
        }
      : (isZoneSi && regionHDC) ||
        (isHelpDesk && regionHDC) ||
        (isHelpDeskAdmin && regionHDC)
      ? async () => {
          if (zoneId) {
            const response = await IntroductionFormApi.getRegions({
              zoneId,
            });
            setSecondRegion(response.data);
          }
        }
      : async (selectedZoneId) => {
          if (selectedZoneId) {
            try {
              const response = await IntroductionFormApi.getRegions({
                zoneId: selectedZoneId,
              });
              setSecondRegion(response.data);
            } catch (error) {
              console.error("Error fetching Regions:", error);
            }
          } else {
            setSecondRegion([]);
            setSecondChapter([]);
            setSecondDistrict([]);
          }
        };

  const secondChapters =
    (isZoneSi && regionHDC) ||
    (isHelpDesk && regionHDC) ||
    (isHelpDeskAdmin && regionHDC)
      ? async () => {
          if (regionId) {
            const response = await IntroductionFormApi.getChapters({
              regionId,
            });
            setSecondChapter(response.data);
          }
        }
      : async (selectedRegionId) => {
          if (selectedRegionId) {
            try {
              const response = await IntroductionFormApi.getChapters({
                regionId: selectedRegionId,
              });
              setSecondChapter(response.data);
            } catch (error) {
              console.error("Error fetching Chapters:", error);
            }
          } else {
            setSecondChapter([]);
            setSecondDistrict([]);
          }
        };

  const secondDistricts = async (selectedChapterId) => {
    if (selectedChapterId) {
      try {
        const response = await IntroductionFormApi.getDistricts({
          chapterId: selectedChapterId,
        });
        setSecondDistrict(response.data);
      } catch (error) {
        console.error("Error fetching Districts:", error);
      }
    } else {
      setSecondDistrict([]);
    }
  };

  useEffect(() => {
    const loadInitialData = async () => {
      // Area list load karna
      if (areaId) {
        try {
          const res = await IntroductionFormApi.getAllArea({ areaId });
          setArea(res.data);
        } catch (err) {
          console.error(err);
        }
      }
      // Member ka HDC data load karna
      if (selectedMember?.memberId) {
        try {
          const response = await Member.getHdcByMemberId({
            memberId: selectedMember.memberId,
          });
          setHdcData(response.data); // Ab hdcData null nahi rahega
        } catch (error) {
          Sentry.captureException(error);
        }
      }
    };
    loadInitialData();
  }, [selectedMember, areaId]);

  useEffect(() => {
    const loadAllHierarchy = async () => {
      if (!hdcData) return;

      setIsLoading(true);
      try {
        // ==========================================
        // --- STRUCTURE 1 DATA LOADING SEQUENCE ---
        // ==========================================
        const app1 = hdcData?.hdcApplications?.[0];
        const areaId1 = app1?.areaId || areaId;

        if (areaId1) {
          const resCluster1 = await IntroductionFormApi.getCluster({
            areaId: areaId1,
          });
          setCluster(resCluster1.data);

          const clusterId1 = app1?.clusterId || clusterId;
          if (clusterId1) {
            const resZone1 = await IntroductionFormApi.getZones({
              clusterId: clusterId1,
            });
            setZone(resZone1.data);

            const zoneId1 = app1?.zoneId || zoneId;
            if (zoneId1) {
              const resRegion1 = await IntroductionFormApi.getRegions({
                zoneId: zoneId1,
              });
              setRegion(resRegion1.data);

              const regionId1 = app1?.regionId || regionId;
              if (regionId1) {
                const resChapter1 = await IntroductionFormApi.getChapters({
                  regionId: regionId1,
                });
                setChapter(resChapter1.data);

                const chapterId1 = app1?.chapterId || chapterId;
                if (chapterId1) {
                  const resDistrict1 = await IntroductionFormApi.getDistricts({
                    chapterId: chapterId1,
                  });
                  setDistrict(resDistrict1.data);
                }
              }
            }
          }
        }

        // ==========================================
        // --- STRUCTURE 2 DATA LOADING SEQUENCE ---
        // ==========================================
        const app2 = hdcData?.hdcApplications?.[1];
        const areaId2 = app2?.areaId || areaId;

        if (areaId2) {
          const resCluster2 = await IntroductionFormApi.getCluster({
            areaId: areaId2,
          });
          setSecondCluster(resCluster2.data);

          // Yahan par same Structure 1 ki tarah fallback diya hai, taki options khali na rahein
          const clusterId2 = app2?.clusterId || clusterId;
          if (clusterId2) {
            const resZone2 = await IntroductionFormApi.getZones({
              clusterId: clusterId2,
            });
            setSecondZone(resZone2.data);

            const zoneId2 = app2?.zoneId || zoneId;
            if (zoneId2) {
              const resRegion2 = await IntroductionFormApi.getRegions({
                zoneId: zoneId2,
              });
              setSecondRegion(resRegion2.data);

              const regionId2 = app2?.regionId || regionId;
              if (regionId2) {
                const resChapter2 = await IntroductionFormApi.getChapters({
                  regionId: regionId2,
                });
                setSecondChapter(resChapter2.data);

                const chapterId2 = app2?.chapterId || chapterId;
                if (chapterId2) {
                  const resDistrict2 = await IntroductionFormApi.getDistricts({
                    chapterId: chapterId2,
                  });
                  setSecondDistrict(resDistrict2.data);
                }
              }
            }
          }
        }
      } catch (error) {
        console.error("Hierarchy Load Error:", error);
      } finally {
        setIsLoading(false);
        setIsLoadingSecond(false);
      }
    };

    loadAllHierarchy();
  }, [hdcData, areaId, clusterId, zoneId, regionId, chapterId]); // Dependencies safely pass ki hain

  const onSubmit = async (event, formikBag) => {
    event.preventDefault();

    try {
      // if (
      //   formikBag.values[MEMBER_HDC_CREATE.DISTRICT] ===
      //   formikBag.values[MEMBER_HDC_CREATE_SECOND.DISTRICT]
      // ) {
      //   toast.show("Same District in both structures", AlertStatus.ERROR);
      //   return false;
      // }
      const data = {
        structureIds: [
          formikBag.values[MEMBER_HDC_CREATE.DISTRICT],
          formikBag.values[MEMBER_HDC_CREATE_SECOND.DISTRICT],
        ],
      };
      const memberId = selectedMember?.memberId;
      await Member.addHdcRequest(memberId, { data });
      toast.show("Successfully Done", AlertStatus.SUCCESS);

      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (error) {
      Sentry.captureException(error);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR,
      );
    }
  };

  console.log(data);
  if (!hdcData) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      {(isLoading || isLoadingSecond) && <Loader />}
      <Formik
        initialValues={{
          // [MEMBER_HDC_CREATE.AREA]:
          // hdcData?.hdcApplications[0]?.areaId || (isHelpDesk && nationalHDC)
          //   ? ""
          //   : areaId,
          // (isHelpDesk && nationalHDC)
          //   ? hdcData?.hdcApplications?.[0]?.areaId : ""
          //   : areaId,
          [MEMBER_HDC_CREATE.AREA]: hdcData?.hdcApplications?.[0]?.areaId
            ? hdcData?.hdcApplications?.[0]?.areaId
            : (isHelpDesk || isHelpDeskAdmin) && nationalHDC
            ? ""
            : areaId,

          [MEMBER_HDC_CREATE.CLUSTER]: hdcData?.hdcApplications?.[0]?.clusterId
            ? hdcData?.hdcApplications?.[0]?.clusterId
            : (isHelpDesk || isHelpDeskAdmin) && areaHDC
            ? ""
            : clusterId,

          [MEMBER_HDC_CREATE.ZONE]: hdcData?.hdcApplications?.[0]?.zoneId
            ? hdcData?.hdcApplications?.[0]?.zoneId
            : (isHelpDesk || isHelpDeskAdmin) && clusterHDC
            ? ""
            : zoneId,

          [MEMBER_HDC_CREATE.REGION]: hdcData?.hdcApplications?.[0]?.regionId
            ? hdcData?.hdcApplications?.[0]?.regionId
            : (isAreaSi && zoneHDC) ||
              (isHelpDesk && zoneHDC) ||
              (isHelpDeskAdmin && zoneHDC)
            ? ""
            : regionId,
          [MEMBER_HDC_CREATE.CHAPTER]: hdcData?.hdcApplications?.[0]?.chapterId
            ? hdcData?.hdcApplications?.[0]?.chapterId
            : (isClusterSi && regionHDC) ||
              (isHelpDesk && regionHDC) ||
              (isHelpDesk && regionHDC) ||
              (isHelpDeskAdmin && regionHDC)
            ? ""
            : chapterId,
          [MEMBER_HDC_CREATE.DISTRICT]:
            hdcData?.hdcApplications?.[0]?.districtId,

          // Second Structure
          [MEMBER_HDC_CREATE_SECOND.AREA]: hdcData?.hdcApplications?.[1]?.areaId
            ? hdcData?.hdcApplications?.[1]?.areaId
            : (isHelpDesk || isHelpDeskAdmin) && nationalHDC
            ? ""
            : areaId,
          [MEMBER_HDC_CREATE_SECOND.CLUSTER]: hdcData?.hdcApplications?.[1]
            ?.clusterId
            ? hdcData?.hdcApplications?.[1]?.clusterId
            : (isHelpDesk || isHelpDeskAdmin) && areaHDC
            ? ""
            : clusterId,
          [MEMBER_HDC_CREATE_SECOND.ZONE]: hdcData?.hdcApplications?.[1]?.zoneId
            ? hdcData?.hdcApplications?.[1]?.zoneId
            : (isHelpDesk || isHelpDeskAdmin) && clusterHDC
            ? ""
            : zoneId,
          [MEMBER_HDC_CREATE_SECOND.REGION]: hdcData?.hdcApplications?.[1]
            ?.regionId
            ? hdcData?.hdcApplications?.[1]?.regionId
            : (isAreaSi && zoneHDC) ||
              (isHelpDesk && zoneHDC) ||
              (isHelpDeskAdmin && zoneHDC)
            ? ""
            : regionId,
          [MEMBER_HDC_CREATE_SECOND.CHAPTER]: hdcData?.hdcApplications?.[1]
            ?.chapterId
            ? hdcData?.hdcApplications?.[1]?.chapterId
            : (isZoneSi && regionHDC) ||
              (isHelpDesk && regionHDC) ||
              (isHelpDeskAdmin && regionHDC)
            ? ""
            : chapterId,
          [MEMBER_HDC_CREATE_SECOND.DISTRICT]:
            hdcData?.hdcApplications?.[1]?.districtId,
        }}
      >
        {({ values, setFieldValue }) => (
          <form
            onSubmit={(event) => onSubmit(event, { values, setFieldValue })}
          >
            <Box style={{ display: "flex" }}>
              <Typography variant="title2" color="#8c8c8c">
                Honorary District Chief
              </Typography>
              <div
                style={{
                  position: "relative",
                  float: "right",
                  top: "-8px",
                  marginLeft: "auto",
                }}
              >
                <IconButton>
                  <CloseIcon onClick={onClose} />
                </IconButton>
              </div>
            </Box>
            <Box style={{ display: "flex" }}>
              <Box
                style={{
                  width: "100%",
                }}
              >
                <Box style={style.personalDetails}>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "65px",
                    }}
                  >
                    <Typography>Member ID</Typography>
                    <Box>: {memberId || "NA"}</Box>
                  </Box>
                  <Box sx={{ display: "flex", gap: "35px" }}>
                    <Typography>Member Name</Typography>
                    <Box>: {fullName || "NA"}</Box>
                  </Box>
                  <Box sx={{ display: "flex", gap: "20px" }}>
                    <Typography>Mainline Position</Typography>
                    <Box>: {mainlinePosition || "NA"}</Box>
                  </Box>
                </Box>
                <Box style={style.memberOrgBox}>
                  <Typography variant="title3" color="#8c8c8c">
                    Mark Hdc(From Organization Structure: 1)
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: isMobile ? "column" : "row",
                      gap: "20px",
                    }}
                  >
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE.AREA}
                      options={getOptions(area, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE.AREA])}
                      label="Area"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE.AREA, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE.AREA,
                            selectedValue.value,
                          );
                        }
                        Clusters(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE.CLUSTER, "");
                        setFieldValue(MEMBER_HDC_CREATE.ZONE, "");
                        setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                        setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                        setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        setCluster([]);
                        setZone([]);
                        setRegion([]);
                        setChapter([]);
                        setDistrict([]);
                      }}
                      style={{ width: "160px" }}
                      disabled={
                        (isHelpDesk && areaHDC) ||
                        (isHelpDeskAdmin && areaHDC) ||
                        (isAreaSi && areaHDC) ||
                        (isHelpDesk && clusterHDC) ||
                        (isHelpDeskAdmin && clusterHDC) ||
                        (isAreaSi && clusterHDC) ||
                        (isClusterSi && clusterHDC) ||
                        (isHelpDesk && zoneHDC) ||
                        (isHelpDeskAdmin && zoneHDC) ||
                        (isAreaSi && zoneHDC) ||
                        (isClusterSi && zoneHDC) ||
                        (isHelpDesk && regionHDC) ||
                        (isHelpDeskAdmin && regionHDC) ||
                        (isZoneSi && regionHDC)
                      }
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE.CLUSTER}
                      options={getOptions(cluster, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE.CLUSTER])}
                      label="Cluster"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE.CLUSTER, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE.CLUSTER,
                            selectedValue.value,
                          );
                        }
                        Zones(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE.ZONE, "");
                        setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                        setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                        setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        setZone([]);
                        setRegion([]);
                        setChapter([]);
                        setDistrict([]);
                      }}
                      style={{ width: "160px" }}
                      disabled={
                        (isHelpDesk && clusterHDC) ||
                        (isHelpDeskAdmin && clusterHDC) ||
                        (isAreaSi && clusterHDC) ||
                        (isClusterSi && clusterHDC) ||
                        (isHelpDesk && zoneHDC) ||
                        (isHelpDeskAdmin && zoneHDC) ||
                        (isAreaSi && zoneHDC) ||
                        (isClusterSi && zoneHDC) ||
                        (isHelpDesk && regionHDC) ||
                        (isHelpDeskAdmin && regionHDC) ||
                        (isZoneSi && regionHDC)
                      }
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE.ZONE}
                      options={getOptions(zone, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE.ZONE])}
                      label="Zone"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE.ZONE, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE.ZONE,
                            selectedValue.value,
                          );
                        }
                        Regions(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                        setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                        setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        setRegion([]);
                        setChapter([]);
                        setDistrict([]);
                      }}
                      style={{ width: "160px" }}
                      disabled={
                        (isHelpDesk && zoneHDC) ||
                        (isHelpDesk && regionHDC) ||
                        (isHelpDeskAdmin && zoneHDC) ||
                        (isHelpDeskAdmin && regionHDC) ||
                        (isAreaSi && zoneHDC) ||
                        (isZoneSi && regionHDC)
                      }
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE.REGION}
                      options={getOptions(region, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE.REGION])}
                      label="Region"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE.REGION,
                            selectedValue?.value,
                          );
                        }
                        Chapters(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                        setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        setChapter([]);
                        setDistrict([]);
                      }}
                      style={{ width: "160px" }}
                      disabled={
                        (isHelpDesk && regionHDC) ||
                        (isHelpDeskAdmin && regionHDC) ||
                        (isZoneSi && regionHDC)
                      }
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE.CHAPTER}
                      options={getOptions(chapter, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE.CHAPTER])}
                      label="Chapter"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE.CHAPTER,
                            selectedValue?.value,
                          );
                        }
                        Districts(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        setDistrict([]);
                      }}
                      style={{ width: "160px" }}
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE.DISTRICT}
                      options={getOptions(district, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE.DISTRICT])}
                      label="District"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE.DISTRICT,
                            selectedValue?.value,
                          );
                        }
                      }}
                      style={{ width: "160px" }}
                    />
                    <Button
                      variant="outlined"
                      style={{
                        width: "80px",
                        height: "30px",
                        marginTop: "5px",
                      }}
                      onClick={() => {
                        // Clear values in the first row dropdowns

                        if (isHelpDesk && areaHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.CLUSTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isHelpDeskAdmin && areaHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.CLUSTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isAreaSi && clusterHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isHelpDeskAdmin && clusterHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isAreaSi && zoneHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isHelpDesk && zoneHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isHelpDeskAdmin && zoneHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isZoneSi && regionHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isHelpDesk && regionHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else if (isHelpDeskAdmin && regionHDC) {
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        } else {
                          setFieldValue(MEMBER_HDC_CREATE.AREA, "");
                          setFieldValue(MEMBER_HDC_CREATE.CLUSTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE.DISTRICT, "");
                        }
                      }}
                      label="Clear"
                    />
                  </Box>

                  {/* Second structure Row */}
                  <Typography variant="title3" color="#8c8c8c">
                    Mark Hdc(From Organization Structure: 2)
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: isMobile ? "column" : "row",
                      gap: "20px",
                    }}
                  >
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE_SECOND.AREA}
                      options={getOptions(area, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE_SECOND.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE_SECOND.AREA])}
                      label="Area"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.AREA, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE_SECOND.AREA,
                            selectedValue?.value,
                          );
                        }
                        secondClusters(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE_SECOND.CLUSTER, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        setSecondCluster([]);
                        setSecondZone([]);
                        setSecondRegion([]);
                        setSecondChapter([]);
                        setSecondDistrict([]);
                      }}
                      style={{ width: "160px" }}
                      disabled={
                        (isHelpDesk && areaHDC) ||
                        (isHelpDeskAdmin && areaHDC) ||
                        (isAreaSi && areaHDC) ||
                        (isHelpDesk && clusterHDC) ||
                        (isHelpDeskAdmin && clusterHDC) ||
                        (isAreaSi && clusterHDC) ||
                        (isClusterSi && clusterHDC) ||
                        (isHelpDesk && zoneHDC) ||
                        (isHelpDeskAdmin && zoneHDC) ||
                        (isAreaSi && zoneHDC) ||
                        (isClusterSi && zoneHDC) ||
                        (isHelpDesk && regionHDC) ||
                        (isHelpDeskAdmin && regionHDC) ||
                        (isZoneSi && regionHDC)
                      }
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE_SECOND.CLUSTER}
                      options={getOptions(secondCluster, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE_SECOND.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE_SECOND.CLUSTER])}
                      label="Cluster"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CLUSTER, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE_SECOND.CLUSTER,
                            selectedValue?.value,
                          );
                        }
                        secondZones(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        setSecondRegion([]);
                        setSecondChapter([]);
                        setSecondDistrict([]);
                      }}
                      style={{ width: "160px" }}
                      disabled={
                        (isAreaSi && areaHDC) ||
                        (isAreaSi && clusterHDC) ||
                        (isClusterSi && zoneHDC) ||
                        (isZoneSi && regionHDC) ||
                        (isHelpDesk && clusterHDC) ||
                        (isHelpDeskAdmin && clusterHDC) ||
                        (isHelpDesk && zoneHDC) ||
                        (isHelpDeskAdmin && zoneHDC) ||
                        (isHelpDesk && regionHDC) ||
                        (isHelpDeskAdmin && regionHDC)
                      }
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE_SECOND.ZONE}
                      options={getOptions(secondZone, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE_SECOND.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE_SECOND.ZONE])}
                      label="Zone"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE_SECOND.ZONE,
                            selectedValue?.value,
                          );
                        }
                        secondRegions(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        setSecondRegion([]);
                        setSecondChapter([]);
                        setSecondDistrict([]);
                      }}
                      style={{ width: "160px" }}
                      disabled={
                        (isHelpDesk && zoneHDC) ||
                        (isHelpDesk && regionHDC) ||
                        (isHelpDeskAdmin && zoneHDC) ||
                        (isHelpDeskAdmin && regionHDC) ||
                        (isAreaSi && zoneHDC) ||
                        (isZoneSi && regionHDC)
                      }
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE_SECOND.REGION}
                      options={getOptions(secondRegion, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE_SECOND.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE_SECOND.REGION])}
                      label="Region"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE_SECOND.REGION,
                            selectedValue?.value,
                          );
                        }
                        secondChapters(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                        setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        setSecondChapter([]);
                        setSecondDistrict([]);
                      }}
                      style={{ width: "160px" }}
                      disabled={
                        (isZoneSi && regionHDC) ||
                        (isHelpDesk && regionHDC) ||
                        (isHelpDeskAdmin && regionHDC)
                      }
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE_SECOND.CHAPTER}
                      options={getOptions(secondChapter, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE_SECOND.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE_SECOND.CHAPTER])}
                      label="Chapter"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE_SECOND.CHAPTER,
                            selectedValue?.value,
                          );
                        }
                        secondDistricts(selectedValue?.value);

                        setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        setSecondDistrict([]);
                      }}
                      style={{ width: "160px" }}
                    />
                    <AutoCompleteDropdown
                      getOptionLabel={(option) => option.name}
                      name={MEMBER_HDC_CREATE_SECOND.DISTRICT}
                      options={getOptions(secondDistrict, "structureId")}
                      //   error={errors[MEMBER_HDC_CREATE_2.BLOCK]}
                      value={Number(values[MEMBER_HDC_CREATE_SECOND.DISTRICT])}
                      label="District"
                      onChange={(selectedValue) => {
                        if (!selectedValue) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else {
                          setFieldValue(
                            MEMBER_HDC_CREATE_SECOND.DISTRICT,
                            selectedValue?.value,
                          );
                        }
                      }}
                      style={{ width: "160px" }}
                    />
                    <Button
                      variant="outlined"
                      style={{
                        width: "80px",
                        height: "30px",
                        marginTop: "5px",
                      }}
                      onClick={() => {
                        // Clear values in the second row dropdowns
                        if (isHelpDesk && areaHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CLUSTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isHelpDeskAdmin && areaHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CLUSTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isAreaSi && clusterHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CLUSTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isHelpDesk && clusterHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CLUSTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isAreaSi && zoneHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isHelpDesk && zoneHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isHelpDeskAdmin && zoneHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isZoneSi && regionHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isHelpDesk && regionHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else if (isHelpDeskAdmin && regionHDC) {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        } else {
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.AREA, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CLUSTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.ZONE, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.REGION, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.CHAPTER, "");
                          setFieldValue(MEMBER_HDC_CREATE_SECOND.DISTRICT, "");
                        }
                      }}
                      label="Clear"
                    />
                  </Box>
                </Box>
                {/* <Typography
                  as="span"
                  style={{
                    color: "#183053",
                    fontSize: "16px",
                    fontWeight: "500",
                    cursor: "pointer",
                    display: !showSecondRow ? "block" : "none", // Show & Hide "Add Another"
                  }}
                  onClick={() => setShowSecondRow(!showSecondRow)}
                >
                  Add Another
                </Typography> */}
                {/* second row  */}
              </Box>
            </Box>
            <Box style={style.buttonStyle}>
              <Button
                style={CommonStyles.buttonStyle}
                variant="outlined"
                onClick={onClose}
                label="CANCEL"
              />
              <Button
                style={CommonStyles.buttonStyle}
                variant="contained"
                type="submit"
                label="SAVE"
              />
            </Box>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default HDCModal;
